"use client";

import React from "react";
import Image2 from  "../../assets/images/KeyZoomedOut.jpg";


export function WarumUns() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#E5F0F1]">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[40px] lg:text-[40px] max-w-[500px]">
            Warum uns wählen?
            </h1>
           
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <div className="mb-3 md:mb-4">
                  <img
                    src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                    className="size-12"
                    alt="Relume logo 1"
                  />
                </div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Erfahrung und Expertise
                </h6>
                <p className="max-w-[240px]">
                Unser Team besteht aus zertifizierten Sicherheitsexperten mit langjähriger Branchenerfahrung.
                </p>
              </div>
              <div>
                <div className="mb-3 md:mb-4">
                  <img
                    src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                    className="size-12"
                    alt="Relume logo 1"
                  />
                </div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Individuelle Lösungen
                </h6>
                <p className="max-w-[240px]">
                Wir passen unsere Dienstleistungen an die spezifischen Bedürfnisse Ihres Unternehmens an.
                </p>
              </div>
              <div>
                <div className="mb-3 md:mb-4">
                  <img
                    src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                    className="size-12"
                    alt="Relume logo 1"
                  />
                </div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Ganzheitlicher Ansatz                </h6>
                <p className="max-w-[240px]">
                Von der Prävention über die Erkennung bis zur Reaktion bieten wir einen umfassenden Sicherheitsansatz                </p>
              </div>
             
            </div>
          </div>
          <div>
            <img
              src={Image2}
              className="w-full h-150 object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

